import { render, staticRenderFns } from "./TakenTab.vue?vue&type=template&id=241526f4"
import script from "./TakenTab.vue?vue&type=script&lang=js"
export * from "./TakenTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports